import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Radio, RadioGroup, FormControlLabel, FormControl, Chip, Divider, Box } from '@mui/material';
import Upload from '../../Common/Upload';
import CustomButton from '../../../componentsII/Buttons';
import { useSelector } from 'react-redux';
import { DownloadIcon } from 'lucide-react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '../../../axios/api';
import { showNotification } from '../../../redux/slices/notificationSlice';
import { useDispatch } from 'react-redux';
import CloudinaryFileUploader from '../../Common/CloudinaryFileUploader';
import { useForm, Controller } from 'react-hook-form';

const Category6C = ({ source }) => {
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      selectedOption: '',
      file: null
    }
  });
  const navigate = useNavigate();
  const selectedOption = watch('selectedOption');
  const selectedYear = useSelector((state) => state.user.selectedYear);
  const [expanded, setExpanded] = useState(false);
  const [learnMore, setLearnMore] = useState(false);
  const [learnMore1, setLearnMore1] = useState(false);
  const [existingData, setExistingData] = useState(null);
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();

  const handleBack = () => {
    navigate(-1);
  };

  const forceDownload = (url, filename) => {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', filename || 'template.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(blobUrl);
      })
      .catch(error => console.error("Error forcing download:", error));
  };

  const handleDownload = async (e, templateId, filename = 'Capital Goods') => {
    e.preventDefault();
    try {
      const response = await api.get(`/scope3/downloadScope3Template?start_year=${selectedYear.start_year}&end_year=${selectedYear.end_year}&amount_based=${selectedOption === 'amount' ? 1 : 0}&other=${selectedOption === 'nights' ? 1 : 0}&source_id=${8}`);
      if (response.data.fileUrl) {
        // Open the file in a new tab or trigger download
        forceDownload(response.data.fileUrl, filename);

        dispatch(showNotification({ message: 'Download successful!', type: 'success' }));
      } else {
        throw new Error("File URL not found in response");
      }
      // const url = window.URL.createObjectURL(new Blob([response.data], { type: response.data.type }));
      // const link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', filename || 'template.pdf');
      // document.body.appendChild(link);
      // link.click();
      // link.remove();

      // dispatch(showNotification({ message: 'Download successful!', type: 'success' }));
    } catch (error) {
      dispatch(showNotification({ message: 'Template not found for category', type: 'error' }));
      // dispatch(showNotification({ 'message': error.message, 'type': 'error' }))
      console.error('Error downloading template:', error);
    }
  };

  const fetchExistingData = async () => {
    try {
      const response = await api.get(`/scope3/getScope3CategoryWiseData?company_id=${user.company.id}&year_id=${selectedYear.id}&cat_id=${8}`);

      if (response.data.data && response.data.data.length > 0) {
        const latestData = response.data.data[0];
        setExistingData({
          id: latestData.id,
          dataType: latestData.amount_wise == 1 ? 'amount' : latestData.other == 1 ? 'nights' : '',
          fileName: latestData.file_name,
          filePath: latestData.file_path,
          send_for_review: latestData.send_for_review
        });

        // Pre-fill form values if existing data exists
        setValue('selectedOption', latestData.amount_wise == 1 ? 'amount' : latestData.other == 1 ? 'nights' : '');

        setValue('file', {
          name: latestData.file_name,
          path: latestData.file_path
        });
      }
    } catch (error) {
      dispatch(showNotification({
        message: 'Error fetching existing data',
        type: 'error'
      }));
      console.error(error);
    }
  };

  useEffect(() => {
    fetchExistingData();
  }, [user.company.id, selectedYear.id]);

  const onSubmit = async (data) => {
    try {
      // Validate required fields
      if (!data.selectedOption) {
        dispatch(showNotification({
          message: 'Please select a purchase data type',
          type: 'error'
        }));
        return;
      }

      if (!data.file || typeof data.file !== 'object' || data.file == "null" || !data.file.name || data.file.name == "null" || !data.file.path || data.file.path == "null") {
        dispatch(showNotification({
          message: 'Please upload a valid file',
          type: 'error'
        }));
        return;
      }


      // Existing submission logic remains the same
      const formData = new FormData();
      formData.append('company_id', user.company.id);
      formData.append('start_year', selectedYear.start_year);
      formData.append('end_year', selectedYear.end_year);
      formData.append('year_id', selectedYear.id);
      formData.append('amount_based', data.selectedOption === 'amount' ? 1 : 0);
      formData.append('quantity_based', data.selectedOption === 'quantity' ? 1 : 0);
      formData.append('other', data.selectedOption === 'nights' ? 1 : 0);
      formData.append('source_id', 8);
      formData.append('file_name', data.file.name);
      formData.append('file_path', data.file.path);
      formData.append('send_for_review', 1);

      // Submit the form
      const response = await api.post('/scope3/saveScope3CategoryWiseData', formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Show success notification
      dispatch(showNotification({
        message: 'Data submitted successfully!',
        type: 'success'
      }));

    } catch (error) {
      // Handle submission error
      dispatch(showNotification({
        message: error.response?.data?.message || 'Submission failed',
        type: 'error'
      }));
      console.error('Submission error:', error);
    }
  };

  const handleSave = async (data) => {
    try {
      // Validate required fields
      if (!data.selectedOption) {
        dispatch(showNotification({
          message: 'Please select a purchase data type',
          type: 'error'
        }));
        return;
      }

      if (!data.file || typeof data.file !== 'object' || data.file == "null" || !data.file.name || data.file.name == "null" || !data.file.path || data.file.path == "null") {
        dispatch(showNotification({
          message: 'Please upload a valid file',
          type: 'error'
        }));
        return;
      }


      // Existing submission logic remains the same
      const formData = new FormData();
      formData.append('company_id', user.company.id);
      formData.append('start_year', selectedYear.start_year);
      formData.append('end_year', selectedYear.end_year);
      formData.append('year_id', selectedYear.id);
      formData.append('amount_based', data.selectedOption === 'amount' ? 1 : 0);
      formData.append('quantity_based', data.selectedOption === 'quantity' ? 1 : 0);
      formData.append('other', data.selectedOption === 'nights' ? 1 : 0);
      formData.append('source_id', 8);
      formData.append('file_name', data.file.name);
      formData.append('file_path', data.file.path);

      // Submit the form
      const response = await api.post('/scope3/saveScope3CategoryWiseData', formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Show success notification
      dispatch(showNotification({
        message: 'Data submitted successfully!',
        type: 'success'
      }));

    } catch (error) {
      // Handle submission error
      dispatch(showNotification({
        message: error.response?.data?.message || 'Submission failed',
        type: 'error'
      }));
      console.error('Submission error:', error);
    }
  };

  const renderQuestion2Content = () => {
    if (selectedOption === 'nights') {
      return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
            <Box sx={{ width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem' }}>
              <div className="bg-green-500 text-white p-1 px-1.5 rounded-full">02</div>
            </Box>

            <div className='flex items-center'>
              <Typography variant="h6">
                To calculate your emissions using average data based on the number of nights stayed, the three columns are:<span style={{ color: 'red' }}>*</span>
              </Typography>
            </div>

          </Box>
          <Box sx={{ ml: 4, mt: -2 }}>
            {learnMore ? (<Typography variant="caption" sx={{ color: 'text.secondary' }}>
              <ul>
                <li>1.Country - Choose a country where the Hotel Stay took place, not the currency used to purchase the stay. For example, if you paid for a Hotel in Mexico with US Dollars, you would select Mexico for this field, not the US.Note: If your desired Country is not listed, use this tool (https://www.hotelfootprints.org/) and the color-coded map to find a Country with the same color-coding (based on the Carbon Emissions per Room Night [KgCO2e]) and a comparable Rooms Footprint, and use that Country instead. For example, Croatia is not listed in CMT-Carbiter, so a Country with a matching color and similar Rooms Footprint (such as Switzerland) can be used in its place.</li>
                <li>2.State (optional) - Optionally, choose a State associated with the Country in which the hotel stay took place from the dropdown list. The State field's dropdown list is dependent on the Country chosen. Select a Country before a State.</li>
                <li>3.Number of Nights Stayed - Enter the total number of nights stayed over your reporting period in this freeform numerical field.</li>
              </ul>
            </Typography>) : <></>}
          </Box>
          <Box sx={{ m: 3, display: 'flex', alignItems: 'center' }}>
            <button
              onClick={handleDownload}
              target="_blank"
              className="flex border-2 gap-1 w-[30%] border-gray-500 bg-green-200 p-2 rounded-full items-center justify-center cursor-pointer"
            >
              <DownloadIcon />Download Template
            </button>
            <div className='ml-2 underline text-blue-500 cursor-pointer' onClick={() => setLearnMore(!learnMore)}>{learnMore ? "Less Info" : "Learn More"}</div>

          </Box>
        </>
      );
    } else if (selectedOption === 'amount') {
      return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
            <Box sx={{ width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem' }}>
              <div className="bg-green-500 text-white p-1 px-1.5 rounded-full">02</div>
            </Box>
            <div className='flex items-center'>
              <Typography variant="h6">
                To calculate your emissions based on the amount spent, the three columns which require data are:<span style={{ color: 'red' }}>*</span>
              </Typography>
            </div>

          </Box>
          <Box sx={{ ml: 4, mt: -2 }}>
            {learnMore1 ? (<Typography variant="caption" sx={{ color: 'text.secondary' }}>
              <ol>
                <li>1.Purchase Spend - Enter the amount of money your organization spent on stays. This can be for a single flight or summed across all flights.</li>
                <li>2.Purchase Spend UOM - Select a currency unit that is applicable to the Purchase Spend.</li>
                <li>3.Country - Select a country where the purchase was made from the dropdown list.</li>
              </ol>
            </Typography>) : <></>}
          </Box>
          <Box sx={{ m: 3, display: 'flex', alignItems: 'center' }}>
            <button
              onClick={handleDownload}
              target="_blank"
              className="flex border-2 gap-1 w-[30%] border-gray-500 bg-green-200 p-2 rounded-full items-center justify-center cursor-pointer"
            >
              <DownloadIcon />Download Template
            </button>
            <div className='ml-2 underline text-blue-500 cursor-pointer' onClick={() => setLearnMore1(!learnMore1)}>{learnMore1 ? "Less Info" : "Learn More"}</div>
          </Box>
        </>
      );
    }
    return null;
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <button
        type='button'
        onClick={handleBack}
        className="flex items-center text-gray-600 hover:text-gray-800 text-lg gap-1 border border-gray-900 px-3 py-1 rounded-md hover:bg-green-200"
      >
        <ArrowLeft className="w-6 h-6" /> Back
      </button>
      <div className="max-w-[800px] w-full mx-auto bg-[#F9FAFB]"    >
        <CardContent sx={{ p: 3 }}>
          {/* Header Section */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
              Business Travel - Hotel Stay
            </Typography>
            <Typography variant="caption" gutterBottom sx={{ pb: 4 }}>
              <div className='flex gap-2 items-center mt-1'>
                scope 3 - Category 6C - <div className='bg-green-200 px-1 rounded-md'>{selectedYear.start_year}</div>
              </div>
            </Typography>
          </Box>

          {/* Expandable Description */}
          <Box sx={{ mb: 2 }}>
            {!expanded ? (
              <>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                  This category accounts for emissions resulting from the accommodation of employees for business-related activities in facilities owned or operated by third parties in the reporting year {selectedYear.start_year}.
                  The most accurate data uses the total number of nights stayed.
                </Typography>
                <div onClick={() => setExpanded(true)} className='underline text-transform-none mt-1 cursor-pointer text-blue-500'>
                  Show more
                </div>
              </>
            ) : (
              <>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                  This category accounts for emissions resulting from the accommodation of employees for business-related activities in facilities owned or operated by third parties in the reporting year {selectedYear.start_year}. The most accurate data uses the total number of nights stayed.
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                  If you don't have this data readily available, you can use the amount spent on hotel accommodation for business travel from your accounting, finance, or HR team. Most companies track business travel in a 3rd party expense tracking system, like SAP Concur or Navan. If you still have questions, please use the message center on the right.
                </Typography>
                <div onClick={() => setExpanded(false)} className='underline text-transform-none mt-1 cursor-pointer text-blue-500'>
                  Show less
                </div>
              </>
            )}
          </Box>

          {/* Question 1 */}
          <Box sx={{ mb: 4, mt: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
              <Box sx={{ width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.875rem' }}>
                <div className="bg-green-500 text-white p-1 px-1.5 rounded-full">01</div>
              </Box>
              <div className='flex items-center'>
                <Typography variant="h6">
                  What type of travel data do you have for reporting year {selectedYear.start_year} ?<span style={{ color: 'red' }}>*</span>
                </Typography>
              </div>

            </Box>
            <Controller
              name="selectedOption"
              control={control}
              rules={{ required: 'Please select an option' }}
              render={({ field }) => (
                <FormControl component="fieldset">
                  <RadioGroup
                    {...field}
                    sx={{ ml: 4 }}
                  >
                    <FormControlLabel
                      value="nights"
                      control={<Radio />}
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography>Number of nights stayed in {selectedYear.start_year}</Typography>
                          <Chip
                            label="Recommended"
                            size="small"
                            sx={{
                              fontSize: '0.75rem',
                              borderColor: 'warning.light',
                              bgcolor: '#f2ead3'
                            }}
                            variant="outlined"
                          />
                        </Box>
                      }
                    />
                    <FormControlLabel
                      value="amount"
                      control={<Radio />}
                      label={`Amount Spent in ${selectedYear.start_year} (e.g., weight, volume, # of units)`}
                    />
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Box>

          {/* Question 2 - Conditional Content */}
          {selectedOption && (
            <>
              <Divider sx={{ my: 3 }} />
              <Box sx={{ mt: 3 }}>
                {renderQuestion2Content()}
                <Box sx={{ ml: 4 }}>
                  <Controller
                    name="file"
                    control={control}
                    render={({ field: { onChange } }) => (
                      <CloudinaryFileUploader
                        multiple={false}
                        allowedTypes="xlsx,xls"
                        onUploadComplete={(fileResponse) => {
                          // onChange(fileResponse);
                          setValue('file', fileResponse);
                        }}
                        existingFiles={existingData ? [{
                          name: existingData.fileName,
                          path: existingData.filePath,
                          filename: existingData.fileName,
                          size: 0 // Add file size if available
                        }] : []}
                      />
                    )}
                  />
                </Box>
              </Box>
              {/* <div className="flex justify-end gap-5 items-center mt-5">
              <CustomButton
                click={() => handleSubmit(handleSave)()}
                className="bg-green-600 hover:bg-green-700 text-white underline"
                text="Save"
              />
                <CustomButton
                  className="bg-green-600 hover:bg-green-700 text-white"
                  text="Submit Data For Review"
                  type='submit'
                />
              </div> */}
              <div className="flex justify-end gap-5 items-center mt-5">
                <CustomButton
                  click={() => handleSubmit(handleSave)()}
                  className={`text-white underline ${existingData?.send_for_review === 1 ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'}`}
                  text="Save"
                  disabled={existingData?.send_for_review === 1}
                />
                <CustomButton
                  className={`text-white ${existingData?.send_for_review === 1 ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'}`}
                  text="Submit Data For Review"
                  type="submit"
                  disabled={existingData?.send_for_review === 1}
                />
              </div>
            </>
          )}
        </CardContent>
      </div>
    </form>
  );
};

export default Category6C;